import React, { useEffect, useMemo, useState } from 'react';
import { Layout, Bubble } from 'tea-component';
import '@/pages/opinion/assets/scss/pages/dataMap/opinionsSources.scss';

import source from '../constants/source.json';
import { getLocale, useIntl } from 'umi';
import Data from '../components/data';
import { getDataMapSource } from '@/pages/opinion/services';
import ChannelLabel from '@/pages/opinion/components/ChannelLabel';
import {
  FilterFixed,
  useFilterDataHook,
} from '@/pages/opinion/components/FilterCommon';

import GuideDataSource from '@/pages/opinion/components/UserGuide/data-source';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import OpinionsSourcesPoint from '@op/operationLog/pages/opinionsSources';

import { connect, useDispatch } from 'umi';
import { OPINION_GUIDE_BOX_LIST6 } from '@/pages/home/components/GuideModule/GuideOpinionBox';
import { GUIDE_TYPE_OPINION_DATA_SOURCE } from '@/pages/home/models/guide';
import { storage } from '@/utils/utils';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { keywordRenderFunc } from '@/pages/opinion/utils/text';
const { Body, Content } = Layout;


const OpinionsSources = ({ userInfo }: any) => {
  const locale = getLocale();
  useInitBuriedPointInfo({ buriedPoint: OpinionsSourcesPoint });
  const { formatMessage } = useIntl();

  const [sources, setSources] = useState(source);

  useEffect(() => {
    getData();
  }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    const list = storage.getLocalStorageItem(OPINION_GUIDE_BOX_LIST6) || [];
    if (userInfo?.openid && !list.includes(userInfo.openid)) {
      dispatch({
        type: 'guide/save',
        payload: {
          guideSys: '',
          guideType: GUIDE_TYPE_OPINION_DATA_SOURCE,
        },
      });
    }
  }, [userInfo]);

  const getData = async () => {
    try {
      const newSources = [];
      const dataMapSource = await getDataMapSource({});

      let dataMapSourceMap: any = {};

      if (
        dataMapSource &&
        Array.isArray(dataMapSource) &&
        dataMapSource.length > 0
      ) {
        dataMapSourceMap = dataMapSource.reduce((result, cur) => {
          const curResult = Object.assign({}, result);
          curResult[cur.source_name?.toLowerCase()] = cur;
          return curResult;
        }, {});
      }

      for (let index = 0; index < sources.length; index += 1) {
        const item: any = Object.assign({}, sources[index]);
        const curSourceName = item.source_name_en?.toLowerCase();

        item.total_games = '-';
        item.total_comments = '-';

        if (dataMapSourceMap[curSourceName]) {
          const { total_games = '-', total_comments = '-' } =
            dataMapSourceMap[curSourceName];

          item.total_games = total_games === '0' ? '0' : total_games;
          item.total_comments = total_comments === '0' ? '0' : total_comments;
        }

        newSources.push(item);
      }

      setSources(newSources);
    } catch (e) {
      console.log(e);
    }
  };

  const { loading, filter, changeFilter, filterOptions } = useFilterDataHook({
    pageName: 'DataMap_Opinions_Sources',
  });

  const renderSources = useMemo(() => {
    if (!filter || !sources || !Array.isArray(sources)) return [];
    return sources.filter((source) => {
      const {
        data_source = [],
        game_type = [],
        channel_type_select = [],
      } = filter;
      const sourceGameType = source.game_type
        .split('/')
        .map((item) => item.toLowerCase());

      const sourceChannelType = source.channel_type_en.toLowerCase();
      const sourceDataSource = source.source_name.toLowerCase();

      let matchGameType = false;
      let matchChannelType = false;
      let matchDataSource = false;

      if (game_type && Array.isArray(game_type) && game_type.length > 0) {
        for (let index = 0; index < game_type.length; index += 1) {
          if (sourceGameType.includes(game_type[index].toLowerCase())) {
            matchGameType = true;
            break;
          }
        }
      } else {
        matchGameType = true;
      }

      if (
        channel_type_select &&
        Array.isArray(channel_type_select) &&
        channel_type_select.length > 0
      ) {
        matchChannelType = channel_type_select.includes(sourceChannelType);
      } else {
        matchChannelType = true;
      }

      if (data_source && Array.isArray(data_source) && data_source.length > 0) {
        matchDataSource = data_source
          .map((item) => item.toLowerCase())
          .includes(sourceDataSource);
      } else {
        matchDataSource = true;
      }

      return matchGameType && matchChannelType && matchDataSource;
    });
  }, [sources, filter]);

  return (
    <Layout className="dbo-opinions-sources">
      <Body>
        <Content>
          <ContentBody
            contentHeard={
              <Content.Header
                className="contentHead-normal"
                title={formatMessage({ id: 'Opinions Sources' })}
              >
                <div className="sources-title">
                  {formatMessage({
                    id: 'In this section you can learn basic information about each data source in various dimensions.',
                  })}
                </div>
              </Content.Header>
            }
          >
            <GuideDataSource></GuideDataSource>

            <FilterFixed
              filter={filterOptions}
              operateShowOptions={null}
              isTile
              confirm={(value) => {
                changeFilter(value);
              }}
            ></FilterFixed>
            <Data
              loading={loading}
              className="dbo-datamap-sources-table dbo-table-sticky"
              justifyClassName="sources-justify"
              searchClassName="sources-search"
              placeholder="Search by source"
              records={renderSources}
              recordKey="source_name_en"
              columns={(pageIndex: number, pageSize: number, search = '') => [
                {
                  key: 'id',
                  header: '#',
                  fixed: 'left',
                  width: 60,
                  render: (record: any, text: any, index: number) =>
                    (pageIndex - 1) * pageSize + index + 1,
                },
                {
                  key: 'data',
                  fixed: 'left',
                  header: formatMessage({ id: 'Data Sources' }),
                  width: 200,
                  render: (record: any) => {
                    return (
                      <ChannelLabel
                        iconClassName={'row-flex-img'}
                        textClassName={'row-flex-text'}
                        channel_name={record.source_name.toLowerCase()}
                        replaceText={
                          locale === 'en-US'
                            ? record.source_name_en
                            : record.source_name_cn
                        }
                      ></ChannelLabel>
                    );
                  },
                },
                // {
                //   key: 'total_games',
                //   header: formatMessage({ id: 'Game monitored' }),
                //   align: 'right',
                //   width: 160,
                //   render: (record: any, text: any, index: number) => {
                //     return record.total_games || '-';
                //   },
                // },
                // {
                //   key: 'total_comments',
                //   header: formatMessage({ id: 'Monthly Comment update' }),
                //   align: 'right',
                //   width: 250,
                //   render: (record: any, text: any, index: number) => {
                //     return record.total_comments || '-';
                //   },
                // },
                {
                  key: 'channel_type',
                  header: formatMessage({ id: 'Channel Type' }),
                  width: 150,
                  render: (record: any) => {
                    return locale === 'en-US'
                      ? record.channel_type_en
                      : record.channel_type_cn;
                  },
                },
                {
                  key: 'characteristic',
                  header: formatMessage({ id: 'Source Feature' }),
                  width: 580,
                  render: (record: any) => {
                    const content =
                      locale === 'en-US'
                        ? record.characteristic_en
                        : record.characteristic_cn;

                    return (
                      <div>
                        <Bubble
                          closeOnScroll
                          style={{ width: 500 }}
                          dark
                          placement="top-start"
                          content={content}
                        >
                          <div>
                            {keywordRenderFunc({
                              text: content,
                              keyword: search,
                            })}
                          </div>
                        </Bubble>
                      </div>
                    );
                  },
                },
                {
                  key: 'game_type',
                  header: formatMessage({ id: 'Game Type' }),
                  width: 230,
                  render: (record: any) => {
                    const { game_type = '' } = record;

                    try {
                      return game_type
                        .split('/')
                        .map((item: string) => formatMessage({ id: item }))
                        .join('/');
                    } catch {
                      return game_type;
                    }
                  },
                },
                {
                  key: 'mertric',
                  header: formatMessage({ id: 'Metric/Engagement' }),
                  width: 580,
                  render: (record: any) => {
                    const content =
                      locale === 'en-US' ? record.module_en : record.module_cn;

                    return (
                      <div>
                        <Bubble
                          style={{ width: 500 }}
                          dark
                          closeOnScroll
                          placement="top-start"
                          content={content}
                        >
                          <div style={{ whiteSpace: 'pre-line' }}>
                            {content}
                          </div>
                        </Bubble>
                      </div>
                    );
                  },
                },
                {
                  key: 'available',
                  header: formatMessage({ id: 'Availability' }),
                  width: 200,
                  render: (record: any) => {
                    return locale === 'en-US'
                      ? record.available_en
                      : record.available_cn;
                  },
                },
                {
                  key: 'url',
                  header: formatMessage({ id: 'Source URL' }),
                  width: 400,
                },
              ]}
            />
          </ContentBody>
        </Content>
      </Body>
    </Layout>
  );
};

export default connect((state: any) => {
  const { loading, home, opinionCommon } = state;
  // console.log('connect', opinionFilter);
  return {
    userInfo: home.userInfo,
  };
})(OpinionsSources);
